import React from "react";
import { useHistory } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";

const PILLARS = [
  {
    label: "WORK",
    color: "#017bef",
    items: ["Coworking", "Desks", "Meeting Rooms", "Conference", "Private Offices"],
  },
  { label: "STAY", color: "#0062c0", items: ["Hotels", "Apartments", "Boutique Hotels"] },
  { label: "PLAY", color: "#6366f1", items: ["Wellness", "Dining", "Adventure", "Events", "Concierge"] },
];

export default function PlatformHero() {
  const history = useHistory();

  return (
    <section className="relative overflow-hidden bg-[#f8fbff] py-20 lg:pb-[46px] lg:pt-[114px]">
      <div className="pointer-events-none absolute left-[26%] top-0 h-[300px] w-[700px] rounded-full bg-[#017bef]/[0.06] blur-[64px]" />

      <div className="relative mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-16 px-[16px] sm:px-8 lg:grid-cols-2">
        <div>
          <p className="text-[14px] font-bold uppercase leading-5 tracking-[1.4px] text-[#017bef]">
            The SPACIA Platform
          </p>
          <h1 className="pt-[16px] text-[40px] font-bold leading-[1.05] tracking-[-1.5px] text-[#0a0a0a] sm:text-[60px] sm:leading-[63px]">
            One Platform.
            <br />
            Every Space.
          </h1>
          <p className="max-w-[512px] pt-6 text-[18px] leading-[29.25px] text-[#717182]">
            Every space on SPACIA under Work, Stay or Play is supported by the same underlying platform.
          </p>
          <p className="max-w-[512px] pt-[20px] text-[16px] leading-[26px] text-[#717182]">
            SPACIA brings together Work, Stay and Play, giving users one platform to discover, book and manage every
            space they need.
          </p>
          <div className="flex flex-wrap gap-[16px] pt-8">
            <button
              type="button"
              onClick={() => history.push("/package-signup")}
              className="inline-flex items-center gap-2 rounded-full bg-[#017bef] px-7 py-3.5 text-[14px] font-bold leading-5 text-white drop-shadow-[0_4px_8px_rgba(1,123,239,0.25)] transition-colors hover:bg-[#0062c0]"
            >
              Get Started
              <ArrowRight className="size-4" />
            </button>
            <button
              type="button"
              onClick={() => history.push("/partner-signup")}
              className="rounded-full border-[1px] border-solid border-[#e5e7eb] bg-white px-7 py-3.5 text-[14px] font-semibold leading-5 text-[#0a0a0a] transition-colors hover:bg-gray-50"
            >
              List Your Space
            </button>
          </div>
        </div>

        <div className="flex flex-col items-center gap-[20px]">
          <span className="rounded-3xl border-[1px] border-solid border-[#017bef]/20 bg-[#012d6e] px-8 py-[20px] text-[9px] font-bold uppercase leading-[13.5px] tracking-[0.9px] text-white/60 drop-shadow-[0_8px_20px_rgba(1,45,110,0.25)]">
            Underlying Platform
          </span>
          <div className="grid w-full grid-cols-1 gap-[16px] sm:grid-cols-3">
            {PILLARS.map(pillar => (
              <div
                key={pillar.label}
                className="rounded-2xl border-[1px] border-solid border-[#e5e7eb] bg-white p-[16px] drop-shadow-[0_2px_8px_rgba(0,0,0,0.04)]"
              >
                <span
                  className="inline-block rounded-[10px] px-2.5 py-1 text-[9px] font-bold leading-[13.5px] text-white"
                  style={{ backgroundColor: pillar.color }}
                >
                  {pillar.label}
                </span>
                <ul className="space-y-1.5 pt-[16px]">
                  {pillar.items.map(item => (
                    <li key={item} className="flex items-center gap-1.5 text-[10px] leading-[15px] text-[#717182]">
                      <ChevronRight className="size-2.5 shrink-0 text-[#017bef]" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
